module.exports = __webpack_public_path__ + "static/media/psp.e72d5c55.jpg";